import SampleLanguageWriteDTO from '../sample-language/SampleLanguageWriteDTO';
import SampleBranding from '../sample-vehicle-model/SampleBranding';
import { FieldOfUse } from './FieldOfUse';
import SampleFormat from './SampleFormat';
import { SampleState } from './SampleState';

export default class SampleWriteDTO {

    public id: number | undefined;
    public printedName: string | undefined;
    public categoryId: number | undefined;
    public fieldOfUse: FieldOfUse | undefined;
    public typeId: number | undefined;
    public state: SampleState | undefined;
    public format: SampleFormat = SampleFormat.STANDARD;
    public weight: number | undefined;
    public es2Key: string | undefined;
    public salesCodes: string[] = [];
    public manufacturerId: number | undefined;
    public sampleLanguages: SampleLanguageWriteDTO[] = [];
    public sspName: string | undefined;
    public categoryDetailIds: number[];
    public mediaId: number | undefined;
    public defaultSampleBranding: SampleBranding = SampleBranding.STANDARD;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined
        this.printedName = data['printedName'] || undefined
        this.fieldOfUse = data['fieldOfUse'] || undefined
        this.categoryId = data['category'] ? data['category'].id : undefined
        this.typeId = data['type'] ? data['type'].id : undefined
        this.state = data['state'] || undefined
        this.es2Key = data['es2Key'] || undefined
        this.salesCodes = data['salesCodes'] || [];
        this.format = data['format'] || SampleFormat.STANDARD;
        this.manufacturerId = data['manufacturerId'] || undefined;
        this.sampleLanguages = data['sampleLanguages'] || [];
        this.weight = data['weight'] || undefined
        this.sspName = data['sspName'] || undefined;
        this.categoryDetailIds = data['categoryDetails'] ? data['categoryDetails'].map((detail: any) => detail.id) : [];
        this.mediaId = data['media'] ? data['media'].id : undefined;
        this.defaultSampleBranding = data['defaultSampleBranding'] || SampleBranding.STANDARD;
    }

}